import "./chartModal.scss";

import React, { Fragment, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import moment from "jalali-moment";
import { Chart } from "chart.js/auto";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const ChartModal = ({
  isOpen,
  onClose,
  buyPrices,
  sellPrices,
  name,
  archive,
}) => {
  // console.log(archive, buyPrices, sellPrices, name);
  // states
  const modalRef = useRef(null);
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const [archiveDate, setArchiveDate] = useState([]);

  const [endDate, setEndDate] = useState(new DateObject());
  const [startDate, setStartDate] = useState(
    // new DateObject().subtract(6, "day")
    archive[0]
  );
  useEffect(() => {
    const dates = archive?.map((d) => moment(d).format("YYYY/MM/DD  HH:mm"));
    setArchiveDate(dates);
    setStartDate(archive.reverse()[0]);
  }, [archive]);

  useEffect(() => {
    if (isOpen) {
      // Destroy the existing chart instance if it exists
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      // Create or update the chart when the modal is opened
      const ctx = chartRef.current.getContext("2d");
      chartInstanceRef.current = new Chart(ctx, {
        type: "line",
        data: {
          labels: archiveDate.slice().reverse(),
          datasets: [
            {
              label: "قیمت خرید",
              data: buyPrices,
              borderColor: "green",
              backgroundColor: "rgba(0, 255, 0, 0.1)",
            },
            {
              label: "قیمت فروش",
              data: sellPrices,
              borderColor: "red",
              backgroundColor: "rgba(255, 0, 0, 0.1)",
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              bodyColor: 'white'
            },
            legend: {
              labels: {
                color: "white",
              },
            },
          },
          scales: {
            // x: {
            //   grid: {
            //     color: "white",
            //     borderColor: "white",
            //   },
            // },
            y: {
              grid: {
                color: "gray",
                borderColor: "gray",
              },
            },
          },
        },
      });
    }
  }, [isOpen, archiveDate]);

  useEffect(() => {
    // Close the modal when clicking outside of it
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      // Filter buyPrices and sellPrices based on selected date range
      const filteredBuyPrices = buyPrices?.filter((price, index) => {
        const date = moment(archiveDate[index], "jYYYY/jMM/jDD HH:mm");
        const gEnd = moment(
          `${endDate.year}/${endDate.month.number}/${endDate.day + 1}`
        );
        if (typeof startDate === "object") {
          const gstart = moment(
            `${startDate.year}/${startDate.month.number}/${startDate.day}`
          );
          return date.isBetween(
            moment.from(gstart.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        } else {
          return date.isBetween(
            moment.from(startDate, "en", "YYYY/MM/DD"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        }
      });

      const filteredSellPrices = sellPrices?.filter((price, index) => {
        const date = moment(archiveDate[index], "jYYYY/jMM/jDD HH:mm");
        const gEnd = moment(
          `${endDate.year}/${endDate.month.number}/${endDate.day + 1}`
        );
        if (typeof startDate === "object") {
          const gstart = moment(
            `${startDate.year}/${startDate.month.number}/${startDate.day}`
          );
          return date.isBetween(
            moment.from(gstart.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        } else {
          return date.isBetween(
            moment.from(startDate, "en", "YYYY/MM/DD  HH:mm"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        }
      });

      const filteredDates = archiveDate?.filter((price, index) => {
        const date = moment(archiveDate[index], "jYYYY/jMM/jDD HH:mm");
        const gEnd = moment(
          `${endDate.year}/${endDate.month.number}/${endDate.day + 1}`
        );
        if (typeof startDate === "object") {
          const gstart = moment(
            `${startDate.year}/${startDate.month.number}/${startDate.day}`
          );
          return date.isBetween(
            moment.from(gstart.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        } else {
          return date.isBetween(
            moment.from(startDate, "en", "YYYY/MM/DD  HH:mm"),
            moment.from(gEnd.locale("en"), "en", "YYYY/MM/DD  HH:mm"),
            null,
            "[]"
          );
        }
      });
      // console.log(filteredDates, filteredBuyPrices, filteredSellPrices);

      // Update the chart with filtered data
      if (chartInstanceRef.current) {
        chartInstanceRef.current.data.datasets[0].data =
          filteredBuyPrices.reverse();
        chartInstanceRef.current.data.datasets[1].data =
          filteredSellPrices.reverse();
        chartInstanceRef.current.data.labels = filteredDates.slice().reverse();
        chartInstanceRef.current.update();
      }
    }
  }, [isOpen, startDate, endDate]);

  return (
    <Fragment>
      {isOpen &&
        ReactDOM.createPortal(
          <div className={`modal ${isOpen ? "open" : ""}`}>
            <div className="modal-content" ref={modalRef}>
              <h2>نمودار فاندامنتال {name} </h2>
              <div className="date">
                <div className="date-item">
                  <label>از تاریخ:</label>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    maxDate={endDate}
                    minDate={new DateObject().subtract(1, "month")}
                    required={true}
                    className="datepicker-input"
                    placeholder="از تاریخ"
                    value={startDate}
                    onChange={(e) => {
                      // if (endDate.unix - e.unix >= 7 * (24 * 60 * 60)) {
                      setStartDate(e);
                      // } else {
                      // }
                    }}
                  >
                    از تاریخ
                  </DatePicker>
                </div>
                <div>
                  <label>تا تاریخ:</label>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    required={true}
                    minDate={startDate}
                    maxDate={new DateObject()}
                    className="datepicker-input"
                    placeholder="تا تاریخ"
                    value={endDate}
                    onChange={setEndDate}
                  >
                    تا تاریخ
                  </DatePicker>
                </div>
              </div>
              <canvas ref={chartRef} />
            </div>
          </div>,
          document.getElementById("modals")
        )}
    </Fragment>
  );
};

export default ChartModal;
